import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import style from "./style.module.css";

const Tooltip2 = props => {
  const { placement = "top", children, tip } = props;
  return !!tip ? (
    <OverlayTrigger placement={placement} overlay={<Tooltip className={style.tooltip}>{tip}</Tooltip>}>
      <span>{children}</span>
    </OverlayTrigger>
  ) : (
    children
  );
};

export default Tooltip2;
